import http from 'hub-http/clients/apiClient';
import { mapCmpObjectData } from 'personalization-lib/utils/assetData/cmp';
const BASE_URL = '/content-management/search/v1';
export const CONTENT_PROPERTIES = {
  NAME: 'hs_name',
  UPDATED_AT: 'hs_updated_at',
  SCREENSHOT_URL: 'hs_screenshot_preview_url',
  AB_STATUS: 'hs_ab_status',
  PERSONALIZATION_VARIANT_STATUS: 'hs_personalization_variant_status',
  PERSONALIZATION_STRATEGY_ID: 'hs_personalization_strategy_id',
  VARIATION: 'hs_variation'
};
export const fetchCmpObjectsByType = ({
  objectType,
  filters,
  properties = [CONTENT_PROPERTIES.NAME, CONTENT_PROPERTIES.SCREENSHOT_URL],
  search,
  offset,
  limit
}) => http.post(`${BASE_URL}/${objectType}`, {
  data: {
    offset: offset !== null && offset !== void 0 ? offset : 0,
    count: limit !== null && limit !== void 0 ? limit : 10,
    query: search,
    includePrivate: false,
    filterGroups: [{
      filters
    }],
    requestOptions: {
      properties
    },
    sorts: [{
      property: CONTENT_PROPERTIES.UPDATED_AT,
      order: 'DESC'
    }]
  }
}).then(data => ({
  total: data.total,
  offset: data.offset,
  results: data.results.map(mapCmpObjectData)
}));